import React from "react";
import Carousel from "react-material-ui-carousel";
import { PositionEnum } from "../../../Model/Enums/PositionEnum";
import { BannerStore } from "../../../Store";

const HouseKeepingBanner = () => {
  return (
    <div className="row">
      <div className="col-12">
        <Carousel
          autoPlay={true}
          swipe={true}
          //   navButtonsAlwaysVisible={false}
          animation={"fade"}
          interval={3000}
          duration={1000}
          indicators={false}
        >
          {BannerStore.getBannerPositionMap(PositionEnum.SUB_CAT_3).map(
            (item, ind) => (
              <div className="pp_product" key={ind}>
                <a>
                  <img
                    className="w-100 img-fluid"
                    src={item.bannerUrl}
                    alt=""
                  />
                </a>
              </div>
            )
          )}
        </Carousel>
      </div>
    </div>
  );
};

export default HouseKeepingBanner;
